import React from "react";
import styled, { css } from "styled-components";

import Modal from "../../../Modal";
import { rem } from "polished";
import Button, { ButtonWrapper } from "../../../Button";
import ListItem from "../ListItem";
import { useDispatch, useSelector } from "react-redux";
import {
  addEdge,
  getEdges,
  removeEdge,
} from "../../../../lib/redux/slices/edges-slice";
import { getTileShape } from "../../../../lib/redux/slices/dimensions-slice";
import ItemDetailModal from "../ItemDetailModal";
import { useUpdateCart } from "../../../../hooks/use-update-cart";

const Edges = ({ data }) => {
  const [selectedData, setSelectedData] = React.useState([]);
  const [open, onSetModal] = React.useState(false);
  const [openDetailModal, onSetDetailModal] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState({});

  const edges = useSelector(getEdges);
  const selectedTile = useSelector(getTileShape);
  const dispatch = useDispatch();
  const { updateCart } = useUpdateCart();

  const isProductionUrl =
    process.env.NODE_ENV === "production" ? "/builderonly/edges/" : "../edges/";

  const edgeImageSimple = {
    bakkant: `${isProductionUrl}edge1_back.png`,
    framkant: `${isProductionUrl}edge1_front.png`,
    hogerkant: `${isProductionUrl}edge1_right.png`,
    vansterkant: `${isProductionUrl}edge1_left.png`,
  };

  const edgeImageLeft = {
    bakkant: `${isProductionUrl}edge2_back.png`,
    framkant: `${isProductionUrl}edge2_front.png`,
    hogerkant: `${isProductionUrl}edge2_right.png`,
    vansterkant: `${isProductionUrl}edge2_left.png`,
  };

  const edgeImageRight = {
    bakkant: `${isProductionUrl}edge2_back.png`,
    framkant: `${isProductionUrl}edge2_front.png`,
    hogerkant: `${isProductionUrl}edge2_left.png`,
    vansterkant: `${isProductionUrl}edge2_right.png`,
  };

  const removeSelected = (key) => {
    const existingEdges = { ...edges };
    delete existingEdges[key];
    dispatch(removeEdge(existingEdges));
    updateCart((storeData) => ({
      ...storeData,
      edges: existingEdges,
    }));
  };

  const attachEdge = (edge) => {
    dispatch(addEdge({ ...edges, ...edge }));
    updateCart((storeData) => ({
      ...storeData,
      edges: { ...storeData.edges, ...edge },
    }));
  };

  const getImage = (edge) => {
    switch (true) {
      case selectedTile === "simple":
        return edgeImageSimple[edge];
      case selectedTile === "left":
        return edgeImageLeft[edge];

      case selectedTile === "right":
        return edgeImageRight[edge];
      default:
        return null;
      // code block
    }
  };

  return (
    <Layout>
      {Object.entries(data.options).map((edge, i) => {
        return (
          <div className="edges" key={edge[0]}>
            <div className="label">
              <div className="edge-placeholder">
                <img
                  src={getImage(edge[0])}
                  alt="edge"
                  style={{
                    transform: `scaleX(${selectedTile === "right" ? -1 : 1})`,
                  }}
                />
              </div>
              <label>{edge[1].label}</label>
            </div>

            {Object.entries(edges).length ? (
              <EdgeList
                data={edges[edge[0]]}
                removeSelected={removeSelected}
                name={edge[0]}
                setSelectedItem={setSelectedItem}
                onSetDetailModal={onSetDetailModal}
              />
            ) : null}
            <ButtonWrapper>
              <Button
                onClick={() => {
                  onSetModal(!open);
                  setSelectedData(edge);
                }}
              >
                VÄLJ {edge[1].label}
              </Button>
            </ButtonWrapper>
          </div>
        );
      })}

      <Modal
        wrapperId={`modal`}
        isOpen={open}
        overlayClick
        handleClose={() => onSetModal(false)}
        styles={{
          maxWidth: "90%",
          maxHeight: "90%",
          height: "100%",
          width: "100%",
          borderRadius: 0,
        }}
        parentStyles={{
          zIndex: 9999,
        }}
        title={data.label}
      >
        <ListItem
          selectedKey={selectedData[0]}
          data={selectedData[1]?.options}
          setSingleData={true}
          onHandleSet={attachEdge}
          onModalClose={() => onSetModal(false)}
          setSelectedItem={setSelectedItem}
          onSetDetailModal={onSetDetailModal}
        />
      </Modal>
      <ItemDetailModal
        selectedItem={selectedItem}
        openDetailModal={openDetailModal}
        onSetDetailModal={onSetDetailModal}
      />
    </Layout>
  );
};
export default Edges;

const EdgeList = ({
  data,
  removeSelected,
  name,
  setSelectedItem,
  onSetDetailModal,
}) => {
  if (!data) return;

  return (
    <EdgeListLayout>
      <div className="item">
        <div className="item-details">
          <div
            className="item-header"
            onClick={() => {
              setSelectedItem(data);
              onSetDetailModal(true);
            }}
          >
            <img src={data.image} alt={data.label} width={60} />
            <div className="title">{data.label}</div>
          </div>
          <div className="remove">
            <div className="close" onClick={() => removeSelected(name)}>
              X
            </div>
          </div>
        </div>
      </div>
    </EdgeListLayout>
  );
};

const EdgeListLayout = styled.div`
  ${({ theme }) => css`
    .item {
      margin-top: ${rem(20)};

      + .item {
        border-top: 1px solid ${theme.colors.gray["400"]};
        margin-top: ${rem(40)};
        padding-top: ${rem(20)};
      }

      .item-details {
        display: flex;
        flex-direction: row;
        align-items: center;

        .item-header {
          flex-grow: 1;
          display: flex;
          flex-direction: row;
          align-items: center;

          .title {
            margin-left: ${rem(15)};
          }
        }
      }

      .remove {
        flex: 0 0 15px;
        max-width: 15px;
        text-align: center;
        cursor: pointer;
      }
    }
  `}
`;

const Layout = styled.div`
  ${({ theme }) => css`
    .edges {
      border-bottom: 1px solid ${theme.colors.gray["400"]};
      margin-bottom: ${rem(30)};
      padding-bottom: ${rem(30)};

      .label {
        margin-bottom: ${rem(15)};
        display: flex;
        align-items: center;

        .edge-placeholder {
          margin-right: ${rem(15)};
          img {
            height: 50px;
          }
        }
      }

      + .edges {
      }
    }
  `}
`;
